import {Stack, Typography} from '@mui/material';
import {ApexOptions} from 'apexcharts';
import Chart from 'react-apexcharts';
import {STYLES} from './styles';

const STACK_PROPS = {
  direction: 'row',
  width: '100%',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
} as const;

export function CommonChart({commonChart}: {commonChart: {key: string; options: ApexOptions; series: number[]}}) {
  if (commonChart.series.length === 0) {
    return (
      <Stack {...STACK_PROPS}>
        <Typography color="#464255" fontWeight={600}>
          Нет данных
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack minHeight={278}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={STYLES.chartLegendHeader}>
        <Typography>Название</Typography>
        <Stack direction="row" alignItems="center" gap={4.4} paddingRight={2}>
          <Typography>Значение</Typography>
          <Typography>%</Typography>
        </Stack>
      </Stack>
      <Chart
        key={commonChart.key}
        options={commonChart.options}
        series={commonChart.series}
        type="donut"
        height={350}
      />
    </Stack>
  );
}

export function PartCharts({partCharts}: {partCharts: {key: string; options: ApexOptions; series: number[]}[]}) {
  if (partCharts.length === 0) {
    return (
      <Stack {...STACK_PROPS}>
        <Typography color="#464255" fontWeight={600}>
          Нет данных
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack direction="row" gap={1} justifyContent="space-around" mt="22px">
      {partCharts.map(({key, options, series}) => (
        <Stack key={key} alignItems="center" gap={2}>
          <Chart options={options} series={series} type="donut" height={106} width={106} />
          <Typography sx={STYLES.chartLegendText}>{options?.labels?.[0]}</Typography>
        </Stack>
      ))}
    </Stack>
  );
}
